import React, { Component } from 'react';
import { ref, base,  } from '../../../config/constants'
import { Grid, Image, Form, Button } from 'semantic-ui-react'
import ImageViewWithActionButtons from './ImageViewWithActionButtons';
import * as UiConsts from '../../../config/UiConstants'



class DesignChatView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chats: [],
            chatText: '',
            loading: true,
        }
    }

    componentDidMount() {
        console.log("dsc1 ++++++++:");
        console.log("dsc12 orderkey:" + this.props.match.params.orderKey);
        console.log("dsc13 order string: designChat/" + this.props.match.params.orderKey)

        //-LWVMq_EHhHTd6s9j7nT
        base.syncState('designChat/' + this.props.match.params.orderKey, {
            context: this,
            asArray: true,
            state: 'chats',
            then(data) {
                console.log("dsc14:" + JSON.stringify(this.state.chats, null, 3));
                this.showChatUI();

                //this.sendClientChatOpenToSlack();
                //sendDesignChatActionToSlack('designChat/' + this.props.match.params.orderKey,'chatOpened')

                this.setState({
                    loading: false
                })
            },
            queries: {
                orderByChild: 'time',
                limitToLast: 1
            }
        });

       
    }

    showChatUI = () => {
        console.log("dsc19 ++++++++:showChatUI");
        this.state.chats.map((message) => {
            <h5>{message.username}</h5>
        })
    }

    // {
    //     "message": "i hate that shit..",
    //     "printbodaAdmin": false,
    //     "time": "Saturday, 19 January 2019",
    //     "username": "client",
    //     "key": "-XXX_LWVMq_EHhHTd6s9j"
    //  }

    addMessageToFirebase = () => {
        console.log("dsc31 ++++++++:addMessageToFirebase");

        let firebaseSaveUrl = 'designChat/' + this.props.match.params.orderKey;
        console.log("dsc32 firebaseSaveUrl:" + firebaseSaveUrl);

        var d = new Date();
        //let newTime = -1 * new Date().getTime();
        let newTime = new Date().getTime();;

        let message = {
            message: this.state.chatText,
            printbodaAdmin: false,
            time: newTime,
            username: "client",
        }


        console.log("dsc32 chatmessage:" + JSON.stringify(message, null, 3));

        //GET CHAT MESSAGE FIREBASE KEY
        let newPostKey = ref.child(firebaseSaveUrl).push().key;
        console.log("dsc33 newPostKey:" + newPostKey);

        // amp_logOrderPlaced(orderObject);
        ref.child(firebaseSaveUrl + '/' + newPostKey).set(message);
        //console.log("dsc33 message saved:"+ref.child);

        //clear text
        this.setState({
            chatText: ''
        })
    }


    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    sendText = () => {
        console.log("dsc2 +++++++++:sendText");
        this.addMessageToFirebase();
    }


    // sendClientChatOpenToSlack = (notifKey) => {
    //     console.log("dsc73 slack12 +++++++ sendClientChatOpenToSlack");
    //     console.log("dsc74 slack13 key:" + this.props.match.params.orderKey);
    //     console.log("dsc741 notifKey:"+notifKey);

    //     let message = "DESIGN CHAT: #" + this.props.match.params.orderKey;

    //     axios.post(serverIp + 'slackNotifs/sendDesignChatNotif', {
    //         apiKey:"-LTS8qkgryCp2DScxtJO",
    //         phonePlusUserFbKey: this.props.match.params.orderKey,
    //         designChatAction:"chatOpened",
    //     })
    //         .then((response) => {
    //             console.log(response.data);

    //             if (response.data) {
    //                 console.log("dsc75 sms send reply:" + JSON.stringify(response.data, null, 3));

    //             } else {
    //                 console.log("dsc76 ERROR:");
    //                 alert("ERROR:"+JSON.stringify(response.data, null, 3));
    //             }
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    //   }

   

    render() {

        const messageList = this.state.chats.map((message) =>

            <ImageViewWithActionButtons message={message} />
            // <ShowDesignChatViewMessage message={message} />
            // <Feed.Event>
            //     <Feed.Content>
            //         <Feed.User>{message.username}</Feed.User>
            //         <Feed.Summary>
            //             {message.message}
            //         </Feed.Summary>
            //     </Feed.Content>
            // </Feed.Event>
        );

        const chatInput =
            <Form >
                <Form.Field>
                    {/* <label>Amount Deposited</label> */}
                    <Form.Input
                        fluid
                        name={'chatText'}
                        value={this.state.chatText}
                        icon='add user'
                        iconPosition='left'
                        placeholder='Enter text'
                        // onFocus={props.amp_logFieldClick}
                        onChange={this.handleTextInputChange}
                        type='text'
                    //error={props.formErrorFieldArray['name']}
                    />
                </Form.Field>
                <Button type='submit' onClick={this.sendText}>Submit</Button>
            </Form>

        return (
            this.state.loading === true ? <UiConsts.LoadingComponent /> :
                <div>
                    {/* <h1>DesignChatView - {this.props.match.params.orderKey} - {this.state.chats.size}</h1> */}
                    <Grid
                        textAlign='center'
                        // style={{ height: '100%' }}
                        verticalAlign='middle' >
                        <Grid.Column style={{ maxWidth: 550 }}>
                            <Image src={require('../../../images/printboda_logo.png')} />
                            {messageList}

                        </Grid.Column>
                    </Grid>

                </div>

        );
    }
}

export default DesignChatView;


// WEBPACK FOOTER //
// ./src/components/newSite/DesignChat/DesignChatView.js